<template>
  <div
    class="time-range-picker el-input__wrapper el-date-editor el-date-editor--timerange"
    :class="['el-range-editor--' + size, disabled ? 'is-disabled' : '']"
    @mouseleave="showClose = false"
    @mouseenter="showClose = true"
    id="month-select"
  >
    <el-icon class="el-icon el-input__icon el-range__icon"><Clock /></el-icon>
    <el-time-select
      v-model="vl[0]"
      ref="startTime"
      @change="handleValue"
      :disabled="disabled"
      :placeholder="startPlaceholder"
      :size="size"
      :start="pickerOptions.start"
      :end="pickerOptions.end"
      :step="pickerOptions.step"
      :maxTime="vl[1]"
      :validate-event="false"
      @blur="startBlur"
    />
    <slot name="range-separator">
      <span class="el-range-separator">{{ rangeSeparator }}</span>
    </slot>
    <el-time-select
      v-model="vl[1]"
      ref="endTime"
      @change="handleValue"
      :disabled="disabled"
      :placeholder="endPlaceholder"
      :size="size"
      :picker-options="{
        start: pickerOptions.start,
        step: pickerOptions.step,
        end: pickerOptions.end,
        minTime: vl[0]
      }"
      :start="pickerOptions.start"
      :end="pickerOptions.end"
      :step="pickerOptions.step"
      :minTime="vl[0]"
      :validate-event="false"
      @blur="endBlur"
    />
    <el-icon
      class="el-icon el-input__icon el-range__close-icon"
      :class="[showClearable ? '' : 'el-range__close-icon--hidden']"
      @click="clearTime"
    >
      <CircleClose />
    </el-icon>
  </div>
</template>
<script setup lang="ts">
import { Clock, CircleClose } from '@element-plus/icons-vue'

const props = defineProps({
  modelValue: {
    type: Array
  },
  disabled: {
    type: Boolean
  },
  rangeSeparator: {
    type: String
  },
  startPlaceholder: {
    type: String,
    default: ''
  },
  endPlaceholder: {
    type: String,
    default: ''
  },
  size: {
    type: String
  },
  clearable: {
    type: Boolean,
    default: true
  },
  pickerOptions: {
    type: Object,
    default: () => {}
  }
})

let vl = ref(['', ''])
let showClose = ref(false)
let startTime = ref()
let endTime = ref()

// 判断是否可以显示清空按钮
const showClearable = computed(
  () =>
    showClose.value &&
    props.clearable &&
    (vl.value[0] != '' || vl.value[1] != '') &&
    !props.disabled
)

// 监听外部值改变
watch(
  () => props.modelValue,
  (n) => {
    if (n[0] !== '' && n[1] !== '') {
      vl.value = n
    } else {
      vl.value[0] = ''
      vl.value[1] = ''
    }
  },
  {
    immediate: true,
    deep: true
  }
)

const emits = defineEmits(['update:modelValue'])

function clearTime() {
  vl.value[0] = ''
  vl.value[1] = ''
  handleValue()
}

// 选择完值
function handleValue() {
  if (!vl.value[0] && !vl.value[1]) {
    emits('update:modelValue', ['', ''])
  } else if (!vl.value[1]) {
    nextTick(() => {
      endTime.value.focus()
    })
  } else if (!vl.value[0]) {
    nextTick(() => {
      startTime.value.focus()
    })
  } else {
    emits('update:modelValue', [vl.value[0], vl.value[1]])
  }
}

// 如果是去焦点时没有选择值，将另一个输入框的值也清除
function startBlur() {
  setTimeout(() => {
    if (!vl.value[0]) {
      vl.value[1] = ''
    }
  }, 200)
}

// 如果是去焦点时没有选择值，将另一个输入框的值也清除，如果选中了值，需要200毫秒才能收到，不知道原因
function endBlur() {
  setTimeout(() => {
    if (!vl.value[1]) {
      vl.value[0] = ''
    }
  }, 200)
}
</script>
<style lang="scss"></style>
